import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconLooseSeatBackCushions = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.6"
      y="22.0232"
      width="3.8"
      height="12.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="21.1255"
      y="22.2192"
      width="23.8"
      height="6.8"
      rx="1.4"
      transform="rotate(-15 21.1255 22.2192)"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="4.62157"
      y="6.49482"
      width="6.8"
      height="14.4841"
      rx="1.4"
      transform="rotate(-15 4.62157 6.49482)"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
    <path
      d="M22.7282 17.2587C22.464 17.316 22.202 17.1529 22.1369 16.8906L21.7114 15.1766L14.9776 25.9716L16.7065 25.5957C16.9712 25.5381 17.2335 25.7018 17.2982 25.9648L17.3297 26.0927C17.3969 26.366 17.2254 26.641 16.9504 26.7007L13.8335 27.378C13.5686 27.4356 13.3062 27.2717 13.2417 27.0084L12.4838 23.9146C12.4169 23.6414 12.5884 23.3668 12.8632 23.307L12.9924 23.2789C13.2571 23.2214 13.5195 23.385 13.5842 23.648L14.0069 25.3661L20.7407 14.5711L19.0143 14.9427C18.75 14.9996 18.4883 14.8361 18.4236 14.5736L18.392 14.4452C18.3246 14.1719 18.4961 13.8968 18.7712 13.837L21.88 13.1609C22.1445 13.1034 22.4067 13.2668 22.4716 13.5295L23.2362 16.6222C23.3038 16.8957 23.1322 17.1711 22.8568 17.2308L22.7282 17.2587Z"
      fill={color}
    />
    <rect
      x="1.6"
      y="32.0232"
      width="29.8"
      height="11.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
  </svg>;
};

IconLooseSeatBackCushions.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconLooseSeatBackCushions;
